import React, { useState, useEffect } from "react"
import { moveFocusTo } from "../../../utils/elements";
import { getAltraCategoriaVeicoloLeggibile } from "../../../utils/utilities"
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from 'design-react-kit';

export const SibaMostraRiepilogo = ({_choice, _targa, _calcolo, _handleCambiaScadenza, _handleBack, _handleNext }) => {
  console.log("SibaMostraRiepilogo.choice:" + _choice);

  const [isModaleVisibile, setModaleVisibile] = useState(true);

  useEffect(() => {
    if (isModaleVisibile) {
      moveFocusTo("modale_ok");
    } else {
      moveFocusTo("conferma_riepilogo");
    }
  })

  const handleClose = () => { setModaleVisibile(false) }
  const onSubmit = () => _handleNext()

  const isCalcoloConSanzioni = (calcolo) => { return (calcolo.importo.sanzioni && calcolo.importo.sanzioni.importo.toFixed(2) !== 0.00) }

  //START RENDERING
  return (
    <Container className="px-2 my-2" id="mostraRiepilogo" tag="section">
      <Container className="px-2 my-2" id="mostraRiepilogo2" tag="section">
        <Modal isOpen={isModaleVisibile} popConfirm style={{ maxWidth: "50%" }}>
          <ModalHeader charCode={215} closeAriaLabel="Close" tag="h5" wrapTag="div" >
            ATTENZIONE
          </ModalHeader>
          <ModalBody tag="div">
            Il pagamento del bollo che stai per effettuare sar&agrave; valido fino a:&nbsp;<br />
            <strong>{_calcolo.dataScadenza.mese.descrizione} {_calcolo.dataScadenza.anno}</strong> <br />
            (incluso)
          </ModalBody>
          <ModalFooter tag="div">
            {/*<Button
              className="btn btn-outline-primary"
              onClick={_handleCambiaScadenza}
            > Cambia annualit&agrave;
  </Button>*/} 
            <Button
              className="btn btn-outline-primary"
              onClick={_handleBack}
            > Torna indietro
            </Button>
            <Button
              id="modale_ok"
              className="btn btn-primary"
              color="primary"
              onClick={handleClose}
            > OK
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
      <Row>
        <Col>
          <h4>Riepilogo dati calcolo</h4>
          <table className="table table-striped table-sm">
            <tbody>
              <tr>
                <th>Categoria veicolo</th>
                <td>{getAltraCategoriaVeicoloLeggibile(_choice)}</td>
              </tr>
              <tr>
                <th>Targa</th>
                <td>{_targa}</td>
              </tr>
              <tr>
                {/* STALIGK-827 */}
                <th>Valido fino a</th>
                <td>{_calcolo.dataScadenza.mese.descrizione} {_calcolo.dataScadenza.anno}</td>
              </tr>
              <tr>
                <th>Validit&agrave;</th>
                <td>{_calcolo.validita} mesi</td>
              </tr>
              {isCalcoloConSanzioni(_calcolo) ? (
                <>
                  <tr>
                    <th>Importo base</th>
                    <td><strong>{parseFloat(_calcolo.importo.tassa.importo).toFixed(2)}</strong> {_calcolo.importo.tassa.divisa.descrizione}</td>
                  </tr>
                  <tr>
                    <th>Sanzioni</th>
                    <td><strong>{parseFloat(_calcolo.importo.sanzioni.importo).toFixed(2)}</strong> {_calcolo.importo.sanzioni.divisa.descrizione}</td>
                  </tr>
                  <tr>
                    <th>Interessi</th>
                    <td><strong>{parseFloat(_calcolo.importo.interessi.importo).toFixed(2)}</strong> {_calcolo.importo.interessi.divisa.descrizione}</td>
                  </tr>
                </>
              ) : React.Fragment
              }
              <tr>
                <th>Importo totale</th>
                <td><strong>{parseFloat(_calcolo.importo.totale.importo).toFixed(2)}</strong> {_calcolo.importo.totale.divisa.descrizione}</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      <Button id="conferma_riepilogo" className="btn btn-primary" color="primary" size="sm" icon={false} tag="button" onClick={onSubmit} >
        {/* STALIGK-834: sost. Procedi al pagamento */}Avanti
      </Button>
    </Container>
  )
}

export default SibaMostraRiepilogo;